import React from 'react';
import * as cls from './section.module.css';

export const Section = ({
  backgroundContrast,
  children,
  className = '',
  classNameRoot = '',
  style = {},
  styleRoot = {},
}) => {
  return (
    <section
      className={`${cls.section} ${backgroundContrast ? cls['background--contrast'] : ''} ${classNameRoot}`}
      style={styleRoot}
    >
      <div className={className} style={style}>
        {children}
      </div>
    </section>
  );
};
